import tw from "tailwind-styled-components";
import { Formik, Form, Field } from "formik";
import moment from "moment";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    OptionText,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar, FaEdit } from "react-icons/fa";
import { useState } from "react";
import { moveOutReasons } from "../../Config";
import SelectOptionModal from "../SelectOptionModal";
import { MdEdit } from "react-icons/md";

const InitiateTenantEvictionStepOne = ({
    setInitiateEviction,
    data,
    tenantDueListLoading,
    tenantDuelistMutate,
    initialFormValues,
    setStep1Values
}) => {

    const [calendarOpen, setCalendarOpen] = useState(false);
    const [otherDateCalendarOpen, setOtherDateCalendarOpen] = useState(false);
    const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);

    const moveInDate = data?.moveInDate ? moment(data.moveInDate) : null;
    const agreementPeriod = data?.agreementPeriod || 0;
    const lockInPeriod = data?.lockInPeriod || 0;
    const noticePeriod = data?.noticePeriod || 0;
    const defaultMoveOutDate = data?.agreementStartDate
        ? moment(data.agreementStartDate).clone().add(agreementPeriod, 'months')
        : null;
    const lockInEndDate = moveInDate?.clone().add(lockInPeriod, "months");
    const today = moment();

    const calculationTypeOptions = [
        { value: 1, label: "Move-out Date" },
        { value: 2, label: "Other Date" },
        { value: 3, label: "Don't Calculate" },
    ];

    const moveOutReasonOptions = moveOutReasons.map(reason => ({
        label: reason.label,
        value: reason.value,
    }));

    const getInitialValues = () => {
        if (data?.moveOutDate && data?.moveOutReason) {
            return {
                moveOutDate: data.moveOutDate,
                moveOutReason: data.moveOutReason,
                otherDate: data.otherDate || (lockInEndDate ? lockInEndDate.format("YYYY-MM-DD") : ""),
                calculationType: data.calculationType || "",
                agreementDate: defaultMoveOutDate ? defaultMoveOutDate.format("YYYY-MM-DD") : "",
            };
        }
        return initialFormValues;
    };

    const handleSubmit = (values) => {
        let calculationDate = "";
        if (values.calculationType === 1) {
            calculationDate = values.moveOutDate;
        } else if (values.calculationType === 2) {
            calculationDate = values.otherDate;
        } else if (values.calculationType === 3) {
            calculationDate = today.format("YYYY-MM-DD");
        }

        if (!values.moveOutDate) {
            toast.error("Moveout date is required")
            return;
        }
        if (!values.moveOutReason) {
            toast.error("Moveout reason is required")
            return;
        }
        if (!values.calculationType) {
            toast.error("Calculation type is required");
            return;
        }

        tenantDuelistMutate({
            tenantId: data?.tenantId,
            date: calculationDate,
            moveOutReason: values?.moveOutReason,
            calculateDues: 1,
        });
    };

    const handleClose = () => {
        setInitiateEviction(false);
    };

    return (
        <Formik
            initialValues={getInitialValues()}
            enableReinitialize={true}
            onSubmit={(values) => {
                setStep1Values(values);
                handleSubmit(values);
            }}
        >
            {({ setFieldValue, values }) => {

                const getCurrentReasonLabel = () => {
                    const selectedReason = moveOutReasons.find(reason => reason.value === values?.moveOutReason);
                    return selectedReason ? selectedReason.label : "Select moveout reason";
                };

                const handleReasonSelect = (selectedValue) => {
                    setFieldValue("moveOutReason", selectedValue);
                };

                return (
                    <Form>
                        <ScrollableContent className="px-4 ">
                            <Wrapper >
                                <CardContainer>
                                    <CardTitle>Agreement Terms</CardTitle>
                                    <CardContent>
                                        <DetailItem>
                                            <DetailLabel>Lock-in Period:</DetailLabel>
                                            <DetailValue>
                                                {lockInEndDate
                                                    ? lockInEndDate.format("MMM D, YYYY")
                                                    : "N/A"}
                                            </DetailValue>
                                        </DetailItem>
                                        <DetailItem>
                                            <DetailLabel>Notice Period:</DetailLabel>
                                            <DetailValue>{noticePeriod} months</DetailValue>
                                        </DetailItem>

                                        <DetailItem>
                                            <DetailLabel>Agreement End Date:</DetailLabel>
                                            <DetailValue>
                                                {defaultMoveOutDate
                                                    ? defaultMoveOutDate.format("MMM D, YYYY")
                                                    : "N/A"}
                                            </DetailValue>
                                        </DetailItem>
                                    </CardContent>
                                </CardContainer>

                                <InputGroup>
                                    <Label htmlFor="moveOutReason">Select Moveout Reason *</Label>

                                    <FieldWrappers onClick={() => setIsReasonModalOpen(true)}>

                                        <Field
                                            type="text"
                                            name="moveOutReasonDisplay"
                                            id="moveOutReasonDisplay"
                                            autoComplete="off"
                                            readOnly
                                            value={getCurrentReasonLabel()}
                                            className="w-full border-none outline-none bg-transparent cursor-pointer"
                                        />
                                        <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />

                                    </FieldWrappers>

                                </InputGroup>

                                <InputGroup>
                                    <Label htmlFor="moveOutDate">Select Move-out Date *</Label>
                                    <FieldWrappers>
                                        <DatePicker
                                            selected={
                                                values.moveOutDate ? new Date(values.moveOutDate) : null
                                            }
                                            onChange={(date) => {
                                                setFieldValue(
                                                    "moveOutDate",
                                                    moment(date).format("YYYY-MM-DD")
                                                );
                                                setCalendarOpen(false);
                                            }}
                                            onClickOutside={() => setCalendarOpen(false)}
                                            onSelect={() => setCalendarOpen(false)}
                                            open={calendarOpen}
                                            onInputClick={() => setCalendarOpen(true)}
                                            dateFormat="yyyy-MM-dd"
                                            className="cursor-pointer items-center z-50"
                                            placeholderText="Select move out date"
                                            showIcon
                                            icon={
                                                <FaRegCalendar className="text-gray-400 text-xs mt-0.5" />
                                            }
                                            showPopperArrow={false}
                                            minDate={new Date(moveInDate.format("YYYY-MM-DD"))}
                                            onFocus={(e) => e.target.blur()}
                                            wrapperClassName="w-full"
                                            name="moveOutDate"
                                            id="moveOutDate"
                                            autoComplete="off"
                                            portalId="root-portal"
                                            popperClassName="react-datepicker-popper"
                                        />
                                    </FieldWrappers>
                                </InputGroup>

                                <InputGroup>
                                    <Label htmlFor="calculationType">Calculate Dues till *</Label>
                                    <div className="grid grid-cols-3 gap-2">
                                        {calculationTypeOptions.map((option) => (
                                            <OptionCard
                                                key={option.value}
                                                isSelected={values.calculationType === option.value}
                                                onClick={() => {
                                                    setFieldValue("calculationType", option.value);
                                                    if (option.value === 2) {
                                                        const nextMonthDate = moment().add(1, 'month').format('YYYY-MM-DD');
                                                        setFieldValue(
                                                            "otherDate",
                                                            nextMonthDate
                                                        );
                                                    } else {
                                                        setFieldValue("otherDate", "");
                                                    }
                                                }}
                                            >
                                                <OptionText>{option.label}</OptionText>
                                            </OptionCard>
                                        ))}
                                    </div>
                                </InputGroup>

                                {values.calculationType === 2 && (
                                    <InputGroup>
                                        <Label htmlFor="otherDate">Date *</Label>
                                        <FieldWrappers className="w-full">
                                            <DatePicker
                                                selected={
                                                    values.otherDate ? new Date(values.otherDate) : null
                                                }
                                                onChange={(date) => {
                                                    setFieldValue(
                                                        "otherDate",
                                                        moment(date).format("YYYY-MM-DD")
                                                    );
                                                    setOtherDateCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setOtherDateCalendarOpen(false)}
                                                onSelect={() => setOtherDateCalendarOpen(false)}
                                                open={otherDateCalendarOpen}
                                                onInputClick={() => setOtherDateCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="cursor-pointer items-center"
                                                placeholderText="Select other date"
                                                showIcon
                                                icon={
                                                    <FaRegCalendar className="text-gray-400 text-xs mt-0.5" />
                                                }
                                                showPopperArrow={false}
                                                minDate={new Date(moveInDate.format("YYYY-MM-DD"))}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                required
                                                name="otherDate"
                                                id="otherDate"
                                                autoComplete="off"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                )}
                            </Wrapper>
                        </ScrollableContent>

                        <ActionSection>
                            <SideCancelBtn type="button" onClick={handleClose}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={tenantDueListLoading}>
                                {tenantDueListLoading ? "Loading..." : "Continue"}
                            </SubmitBtn>
                        </ActionSection>

                        <SelectOptionModal
                            isOpen={isReasonModalOpen}
                            onClose={() => setIsReasonModalOpen(false)}
                            title="Select Moveout Reason"
                            options={moveOutReasonOptions}
                            selectedValue={values.moveOutReason}
                            onSelect={handleReasonSelect}
                            searchPlaceholder="Search moveout reasons..."
                        />
                    </Form>
                );
            }}
        </Formik>
    );
};

// Styled Components
const OptionCard = tw.div`
  flex flex-col items-center justify-center p-2 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isSelected
            ? "bg-blue-50 border-blue-500"
            : "bg-white hover:bg-gray-50"}
`;
const CardContainer = tw.div`bg-white shadow-md rounded-lg p-4 border border-gray-200`;
const CardTitle = tw.h3`text-base font-semibold text-gray-700 mb-4 border-b pb-2`;
const CardContent = tw.div`flex flex-col gap-2`;
const DetailItem = tw.div`flex justify-between items-center`;
const DetailLabel = tw.span`text-gray-600 font-normal text-sm`;
const DetailValue = tw.span`font-medium text-gray-800 text-sm`;

export default InitiateTenantEvictionStepOne;